import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=6f5d68d2&scoped=true"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"
import style0 from "./Character.vue?vue&type=style&index=0&id=6f5d68d2&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=6f5d68d2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d68d2",
  null
  
)

export default component.exports